/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Typography } from "@mui/material";
import StyledStatusTag from "./StyledStatusTag";
import { useSelector } from "react-redux";

const StatusTag = ({ status }) => {

const statusColorGuide = useSelector((state) => state?.authentication?.colorStatus?.data);

  const getStatusColor = (status) => {
    const checkStatus = status?.replace(/_/g, ' ').toLowerCase();
    if(checkStatus === "returned"){
      return "#FD7E14";
    } else if(checkStatus === "kept"){
      return "#136538";
    }
    return statusColorGuide?.find((item) => 
      item?.label?.toLowerCase() === checkStatus
    )?.text_color || "#2476D7";
  };
  const getStatusBg = (status) => {
    const checkStatus = status?.replace(/_/g, ' ').toLowerCase();
    if(checkStatus === "returned"){
      return "#FD7E141A";
    } else if(checkStatus === "kept"){
      return "#1365381A";
    } else {
      return statusColorGuide?.find((item) => 
        item?.label?.toLowerCase() === checkStatus
      )?.background_color || "#2476D71A";
    }
  };

  return (
    <StyledStatusTag>
      <Box className='status-tag' style={{ background: getStatusBg(status) }}>
        <Typography
          className='status-tag-text'
          sx={{ color: getStatusColor(status) }}
        >
          {status?.replace(/_/g, ' ')}
        </Typography>
      </Box>
    </StyledStatusTag>
  );
};

export default StatusTag;
